import { WithId, WithTimestamp } from './typeUtils';
import { FeedContentWidgetType } from './feedTemplate';
import { Mcm } from './mcm';
import { Audience } from './audience';
import { BasePaginationAndSearch } from './pagination';
import { BaseTranslationAggregationParams } from '../lib/translation';
import { ContentTemplateTranslation } from './translation';
import { DailyProgramCta } from './dailyProgram';

export interface NewContentTemplateLegacy {
  name: string;
  content: string;
  property: string;
  hideFromDigitalDailyProgram?: boolean;
  params?: ContentTemplateParams;
  archived?: boolean;
  notNative?: boolean;
}

export interface BareContentPropertyInfo {
  property: string;
}

export interface BasicContentTemplate {
  type?: 'basic';
}

export interface OfferContentTemplate {
  type: 'offer';
  description: string;
  images: string[];
}

export interface MessageContentTemplate {
  type: 'message';
  description: string;
}

export interface InfoContentTemplate {
  type: 'info';
  description: string;
  appearance: 'card' | 'questionAndAnswer';
}

export type ContentTemplateType = Exclude<BareContentTemplate['type'], undefined>;

export const ALL_CONTENT_TEMPLATE_TYPES: ContentTemplateType[] = [
  'basic',
  'offer',
  'message',
  'info',
];
export const ALL_INFO_CONTENT_APPEARANCES: Array<InfoContentTemplate['appearance']> = [
  'card',
  'questionAndAnswer',
];

export type NewContentTemplate = Omit<NewContentTemplateLegacy, 'property'> & {
  brand: string;
  properties: BareContentPropertyInfo[];
  source?: string;
  tags: string[];
  mcm?: Mcm;
  audience?: Audience;
  callToActions: DailyProgramCta[];
} & (BasicContentTemplate | OfferContentTemplate | MessageContentTemplate | InfoContentTemplate);

export type BareContentTemplateLegacy = NewContentTemplateLegacy & WithId & Partial<WithTimestamp>;
export type BareContentTemplate = NewContentTemplate &
  WithId &
  Partial<WithTimestamp> & {
    translations?: ContentTemplateTranslation;
  };

export type FeedEditorElementType = 'text' | 'image';

export interface EventRundownFilter {
  segments?: string[];
  levels?: string[];
  attributes?: string[];
  venues?: string[];
}

export interface EventRundownTimeGrouping {
  name: string;
  startTime: number; // In minutes since day start
}

export interface MultiDayConfig {
  startDate: string;
  endDate: string;
}

export interface ContentTemplateParams {
  eventId?: string;
  venueId?: string;
  venueRundownConfig?: string[];
  venueMealPeriodsConfig?: string[];
  text?: string;
  startDateOffset?: number; // In days
  endDateOffset?: number; // In days
  widgetType?: FeedContentWidgetType;
  eventRundownFilter?: EventRundownFilter;
  eventRundownTitle?: string;
  // undefined: use default, empty string: don't show, otherwise: use the value
  eventRundownDeckPrefix?: string;
  // array of name / start time
  eventRundownTimeGrouping?: EventRundownTimeGrouping[];
  eventRundownRemoveTimeDash?: boolean;
  eventRundownShowDescription?: boolean;
  multiDayConfig?: MultiDayConfig;
  eventRundownHideEndTime?: boolean;
  eventTemplateInstance?: number;
}

export interface VenueRundownConfig {
  venues: string[];
}

export type PaginateContentTemplateParams = BasePaginationAndSearch<BareContentTemplate> & {
  propertyId?: string;
  archived?: boolean;
  tags?: string[];
  types?: ContentTemplateType[];
  startDate?: string;
  endDate?: string;
} & BaseTranslationAggregationParams;
